import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import styles from './Zones.module.css';
import { useTheme } from '../ThemeContext';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import Chip from '@mui/material/Chip';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import { Dialog, DialogTitle, DialogContent, DialogActions, TextField, } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import { TbZoomInAreaFilled } from "react-icons/tb"; //add zone icon
import { TbZoomOutAreaFilled } from "react-icons/tb"; //remove zone icon
import { TbCircleDashedLetterT } from "react-icons/tb"; // add Tag
import { TbCircleDashedLetterC } from "react-icons/tb"; // add Tag Category
import { GrCycle } from 'react-icons/gr'; // Closed Loop indicator
import { CiEdit } from "react-icons/ci";
import { RiDeleteBack2Line } from "react-icons/ri";









const ZONE_KEYS = [
  'Canter',
  'Cant Saw',
  'Side Board',
  'Headrig',
  'Resaw',
  'Edger',
  'Gang Saw',
  'Sawmill Fence',
  'Sawmill Trimmer Length',
  'Planer Infeed',
  'Planer Outfeed',
  'Planer Fence',
  'Planer Trimmer Length',
  'Other'
];

const storageKey = 'zoneStatusByLocation';
const ALL_LOCATIONS_VALUE = '__ALL__';
const ALL_COMPANIES_VALUE = '__ALL_COMPANIES__';
const ensureArray = (value) => (Array.isArray(value) ? value : []);

const Zones = () => {
  const { theme } = useTheme();
  const isDark = theme === 'dark';

  // Locations fetched from backend (Company + Division + LocationID)
  const [locations, setLocations] = useState([]);
  const [selectedLocationId, setSelectedLocationId] = useState('');
  const [selectedCompanyName, setSelectedCompanyName] = useState('');
  const [addTagOpen, setAddTagOpen] = useState(false);
  const [addZoneOpen, setAddZoneOpen] = useState(false);
  const [addCategoryOpen, setAddCategoryOpen] = useState(false);
  const [tagName, setTagName] = useState('');
  const [tagDesc, setTagDesc] = useState('');
  const [tagCategories, setTagCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState('');
  const [newCategoryName, setNewCategoryName] = useState('');
  const ADD_NEW_VALUE = '__ADD_NEW__';



  // Fetch locations
  useEffect(() => {
    const fetchLocations = async () => {
      try {
        const response = await fetch(`/api/`);
        const result = await response.json();
        const list = (result?.locationTable || []).map((r) => ({
          id: r.LocationID,
          companyName: r.CompanyName,
          divisionName: r.DivisionName,
          label: r.CompanyAndDivision || [r.CompanyName, r.DivisionName].filter(Boolean).join(' - '),
        }));
        setLocations(list);
      } catch (e) {
        // Fallback: no server, keep empty list
        console.error('Failed to fetch locations', e);
      }
    };
    fetchLocations();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  //------------------------------------HANDLE CLICKS (ONCLICK) FUNCTIONS----------------------------------


//for opening ADD LOCATION dialog
  const handleAddTagOpen = () => {
    setAddTagOpen(true);
  };
  const handleAddTagClose = () => {
    setAddTagOpen(false);
    setTagName('');
    setTagDesc('');
    setSelectedCategory('');
    setNewCategoryName('');
  };
  // Add Category dialog handlers
  const [categoryNameInput, setCategoryNameInput] = useState('');
  const handleAddCategoryOpen = () => setAddCategoryOpen(true);
  const handleAddCategoryClose = () => { setAddCategoryOpen(false); setCategoryNameInput(''); };
  const handleSaveCategory = async () => {
    try {
      if (!categoryNameInput.trim()) return;
      const res = await fetch(`/api/tags/categories`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ name: categoryNameInput.trim() })
      });
      await res.json();
      handleAddCategoryClose();
      try {
        const data2 = await fetchJson(`/api/tags/categories`);
        setTagCategories(ensureArray(data2));
      } catch (err) {
        console.error('Failed to reload tag categories', err);
        setTagCategories([]);
      }
    } catch (e) { console.error('Failed to add category', e); }
  };
  // Add Zone dialog control
  const [zoneName, setZoneName] = useState('');
  const [zoneDesc, setZoneDesc] = useState('');
  const [allTags, setAllTags] = useState([]);
  const [selectedTagIds, setSelectedTagIds] = useState([]);
  const [selectedScanZone, setSelectedScanZone] = useState('');
  const [zonesTable, setZonesTable] = useState([]);
  const [closedLoopScanZones, setClosedLoopScanZones] = useState(new Set());
  const [activeScanZones, setActiveScanZones] = useState(new Set());
  const [selectedTagCategoryFilter, setSelectedTagCategoryFilter] = useState('');

  const fetchJson = useCallback(async (url, options = {}) => {
    const response = await fetch(url, options);
    const contentType = response.headers.get('content-type') || '';
    const payload = contentType.includes('application/json')
      ? await response.json()
      : await response.text();

    if (!response.ok) {
      const message = typeof payload === 'string'
        ? payload
        : payload?.message || `Request failed: ${response.status}`;
      throw new Error(message);
    }

    return payload;
  }, []);

  useEffect(() => {
    const run = async () => {
      try {
        const data = await fetchJson(`/api/tags/categories`);
        setTagCategories(ensureArray(data));
      } catch (e) {
        console.error('Failed to load tag categories', e);
        setTagCategories([]);
      }
    };
    run();
  }, [fetchJson]);

  useEffect(() => {
    const run = async () => {
      try {
        const data = await fetchJson(`/api/tags`);
        setAllTags(ensureArray(data));
      } catch (e) {
        console.error('Failed to load tags', e);
        setAllTags([]);
      }
    };
    run();
  }, [fetchJson]);

  const refreshRequestId = useRef(0);
  const previousLocationsRef = useRef(locations);

  const locationLabelById = useMemo(() => {
    const map = new Map();
    (locations || []).forEach((loc) => {
      if (loc && loc.id !== undefined && loc.id !== null) {
        map.set(String(loc.id), loc.label);
      }
    });
    return map;
  }, [locations]);

  const companyOptions = useMemo(() => {
    const seen = new Set();
    return (locations || []).reduce((options, loc) => {
      if (loc?.companyName && !seen.has(loc.companyName)) {
        seen.add(loc.companyName);
        options.push(loc.companyName);
      }
      return options;
    }, []);
  }, [locations]);

  const filteredLocations = useMemo(() => {
    if (selectedCompanyName === ALL_COMPANIES_VALUE) return locations;
    if (!selectedCompanyName) return [];
    return (locations || []).filter((loc) => loc.companyName === selectedCompanyName);
  }, [locations, selectedCompanyName]);

  const handleCompanyChange = (event) => {
    const nextCompanyName = event.target.value;
    setSelectedCompanyName(nextCompanyName);

    if (!nextCompanyName) {
      setSelectedLocationId('');
      return;
    }

    if (nextCompanyName === ALL_COMPANIES_VALUE) {
      setSelectedLocationId(ALL_LOCATIONS_VALUE);
      return;
    }

    const firstLocation = locations.find((loc) => loc.companyName === nextCompanyName);
    setSelectedLocationId(firstLocation?.id === undefined || firstLocation?.id === null ? '' : String(firstLocation.id));
  };

  const handleLocationChange = (event) => {
    setSelectedLocationId(String(event.target.value));
  };

  const tagsByName = useMemo(() => {
    const map = new Map();
    (allTags || []).forEach((tag) => {
      if (tag && typeof tag.Name === 'string') {
        const key = tag.Name.trim().toLowerCase();
        if (key) {
          const value = tag.TagCategoryID ?? tag.TagCategoryId;
          if (value !== undefined && value !== null) {
            map.set(key, String(value));
          }
        }
      }
    });
    return map;
  }, [allTags]);

  const tagCategoryLabelById = useMemo(() => {
    const map = new Map();
    (tagCategories || []).forEach((cat) => {
      if (cat) {
        const id = cat.TagCategoryID ?? cat.id;
        if (id !== undefined && id !== null) {
          map.set(String(id), cat.Name || String(id));
        }
      }
    });
    return map;
  }, [tagCategories]);

  const selectedLocationLabel = useMemo(() => {
    if (!selectedLocationId) return 'None';
    if (selectedLocationId === ALL_LOCATIONS_VALUE) return 'All';
    const label = locationLabelById.get(String(selectedLocationId));
    return label || String(selectedLocationId);
  }, [selectedLocationId, locationLabelById]);

  const tableTitle = useMemo(() => `${selectedLocationLabel} Zones`, [selectedLocationLabel]);

  const computeZoneState = (rows) => {
    const list = Array.isArray(rows) ? rows : [];
    const active = new Set(
      list
        .map((r) => Number(r.ScanZone))
        .filter((n) => Number.isFinite(n))
    );
    const closed = new Set(
      list
        .filter((r) => typeof r.Tags === 'string' && r.Tags.toLowerCase().split(',').map((s) => s.trim()).includes('closed loop'))
        .map((r) => Number(r.ScanZone))
        .filter((n) => Number.isFinite(n))
    );
    return { list, active, closed };
  };

  const fetchZonesForSelection = useCallback(async (locationId) => {
    if (!locationId) {
      return computeZoneState([]);
    }

    if (locationId === ALL_LOCATIONS_VALUE) {
      const validLocations = locations.filter((loc) => loc && loc.id !== undefined && loc.id !== null);
      if (!validLocations.length) {
        return computeZoneState([]);
      }

      const aggregated = [];

      for (const loc of validLocations) {
        try {
          const res = await fetch(`/api/zones/by-location/${loc.id}`);
          if (!res.ok) {
            const message = await res.text();
            console.error(`Failed to load zones for location ${loc.id}:`, message);
            continue;
          }
          const rows = await res.json();
          const normalized = (Array.isArray(rows) ? rows : []).map((row) => ({
            ...row,
            LocationID: row.LocationID ?? loc.id,
          }));
          aggregated.push(...normalized);
        } catch (err) {
          console.error('Failed to request zones for location', err);
        }
      }

      return computeZoneState(aggregated);
    }

    const res = await fetch(`/api/zones/by-location/${locationId}`);
    if (!res.ok) {
      const message = await res.text();
      throw new Error(message || 'Failed to load zones');
    }
    const rows = await res.json();
    const parsedLocationId = Number(locationId);
    const normalizedRows = (Array.isArray(rows) ? rows : []).map((row) => ({
      ...row,
      LocationID: row.LocationID ?? (Number.isFinite(parsedLocationId) ? parsedLocationId : locationId),
    }));
    return computeZoneState(normalizedRows);
  }, [locations]);

  const refreshZonesForSelection = useCallback(async (locationId) => {
    const targetId = locationId;
    if (!targetId) {
      refreshRequestId.current += 1;
      setZonesTable([]);
      setActiveScanZones(new Set());
      setClosedLoopScanZones(new Set());
      return;
    }

    const requestId = ++refreshRequestId.current;

    try {
      const { list, active, closed } = await fetchZonesForSelection(targetId);
      if (requestId !== refreshRequestId.current) return;
      setZonesTable(list);
      setActiveScanZones(active);
      setClosedLoopScanZones(closed);
    } catch (e) {
      if (requestId !== refreshRequestId.current) return;
      console.error('Failed to load zones for selection', e);
      setZonesTable([]);
      setActiveScanZones(new Set());
      setClosedLoopScanZones(new Set());
    }
  }, [fetchZonesForSelection]);

  const handleAddZoneOpen = () => {
    setEditingZoneId(null);
    setAddZoneOpen(true);
  };
  const handleAddZoneClose = () => {
    setAddZoneOpen(false);
    setZoneName('');
    setZoneDesc('');
    setSelectedTagIds([]);
    setSelectedScanZone('');
  };
//--------------------------------

  // Load tag categories when dialog opens
  useEffect(() => {
    if (!addTagOpen) return;
    const run = async () => {
      try {
        const data = await fetchJson(`/api/tags/categories`);
        setTagCategories(ensureArray(data));
      } catch (e) {
        console.error('Failed to load tag categories', e);
        setTagCategories([]);
      }
    };
    run();
  }, [addTagOpen, fetchJson]);

  const handleSaveTag = async () => {
    try {
      if (!tagName.trim()) return;

      // If adding a new category, create it first
      let categoryId = selectedCategory;
      if (selectedCategory === ADD_NEW_VALUE) {
        if (!newCategoryName.trim()) return;
        const resCat = await fetch(`/api/tags/categories`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ name: newCategoryName.trim() })
        });
        const cat = await resCat.json();
        categoryId = String(cat.TagCategoryID || cat.id);
      }

      // Create the tag
      await fetch(`/api/tags`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ name: tagName.trim(), description: tagDesc.trim(), tagCategoryID: Number(categoryId) || null })
      });

      handleAddTagClose();
    } catch (e) {
      console.error('Failed saving tag', e);
    }
  };

  // Load all tags when Add Zone dialog opens
  useEffect(() => {
    if (!addZoneOpen) return;
    const run = async () => {
      try {
        const data = await fetchJson(`/api/tags`);
        setAllTags(ensureArray(data));
      } catch (e) { console.error('Failed to load tags', e); }
    };
    run();
  }, [addZoneOpen, fetchJson]);

  // Fetch zones for selected location to color buttons
  useEffect(() => {
    refreshZonesForSelection(selectedLocationId);
  }, [selectedLocationId, refreshZonesForSelection]);

  useEffect(() => {
    if (selectedLocationId === ALL_LOCATIONS_VALUE && previousLocationsRef.current !== locations) {
      refreshZonesForSelection(ALL_LOCATIONS_VALUE);
    }
    previousLocationsRef.current = locations;
  }, [locations, selectedLocationId, refreshZonesForSelection]);

  useEffect(() => {
    if (!selectedLocationId) {
      return;
    }

    if (selectedLocationId === ALL_LOCATIONS_VALUE) {
      if (selectedCompanyName !== ALL_COMPANIES_VALUE) {
        setSelectedCompanyName(ALL_COMPANIES_VALUE);
      }
      return;
    }

    const selectedLocation = locations.find((loc) => String(loc.id) === String(selectedLocationId));
    if (selectedLocation?.companyName && selectedCompanyName !== selectedLocation.companyName) {
      setSelectedCompanyName(selectedLocation.companyName);
    }
  }, [locations, selectedCompanyName, selectedLocationId]);

  const handleSaveZone = async () => {
    try {
      if (!zoneName.trim()) return;
      if (!selectedLocationId || selectedLocationId === ALL_LOCATIONS_VALUE) {
        window.alert('Select a specific location before saving a zone.');
        return;
      }
      const url = editingZoneId ? `/api/zones/${editingZoneId}` : `/api/zones`;
      const res = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ name: zoneName.trim(), description: zoneDesc.trim(), tagIds: selectedTagIds.map(Number), scanZone: selectedScanZone === '' ? null : Number(selectedScanZone), locationId: Number(selectedLocationId) })
      });
      const out = await res.json();
      if (!res.ok) throw new Error(out?.message || 'Failed creating zone');
      handleAddZoneClose();
      await refreshZonesForSelection(selectedLocationId);
    } catch (e) { console.error('Failed to save zone', e); }
  };

  const [editingZoneId, setEditingZoneId] = useState(null);
  const handleEditZone = async (row) => {
    try {
      const res = await fetch(`/api/zones/${row.ZoneID}`);
      const data = await res.json();
      if (!res.ok) throw new Error('Failed to load zone');
      setZoneName(data.ZoneName || '');
      setZoneDesc(data.ZoneDesc || '');
      setSelectedScanZone(data.ScanZone !== null && data.ScanZone !== undefined ? String(data.ScanZone) : '');
      setSelectedTagIds((data.TagIDs || []).map(String));
      if (selectedLocationId === ALL_LOCATIONS_VALUE && data.LocationID !== undefined && data.LocationID !== null) {
        setSelectedLocationId(String(data.LocationID));
      }
      setEditingZoneId(row.ZoneID);
      setAddZoneOpen(true);
    } catch (e) { console.error('Edit load failed', e); }
  };

  const handleDeleteZone = async (row) => {
    const ok = window.confirm(`Delete zone "${row.ZoneName}"?`);
    if (!ok) return;
    try {
      const res = await fetch(`/api/zones/${row.ZoneID}`, { method: 'DELETE' });
      if (!res.ok) throw new Error('Delete failed');
      await refreshZonesForSelection(selectedLocationId);
    } catch (e) { console.error('Delete zone failed', e); }
  };

  const tableRows = useMemo(() => {
    const rows = (zonesTable || []).map((r) => {
      const rawId = r.LocationID ?? null;
      const idString = rawId !== null ? String(rawId) : null;
      const label = idString ? (locationLabelById.get(idString) || '') : '';
      const categoryIds = new Set();
      if (typeof r.Tags === 'string') {
        r.Tags.split(',').map((s) => s.trim()).filter(Boolean).forEach((name) => {
          const catId = tagsByName.get(name.toLowerCase());
          if (catId) {
            categoryIds.add(catId);
          }
        });
      }
      const categories = Array.from(categoryIds);
      const categoryNames = categories
        .map((id) => tagCategoryLabelById.get(String(id)) || '')
        .filter(Boolean);
      return { id: r.ZoneID, ...r, LocationID: rawId, LocationName: label, TagCategoryIds: categories, TagCategoryNames: categoryNames.join(', ') };
    });
    const filterId = selectedTagCategoryFilter ? String(selectedTagCategoryFilter) : '';
    if (!filterId) {
      return rows;
    }
    return rows.filter((row) => Array.isArray(row.TagCategoryIds) && row.TagCategoryIds.includes(filterId));
  }, [zonesTable, locationLabelById, tagsByName, tagCategoryLabelById, selectedTagCategoryFilter]);

  return (
    <aside className={`${styles.zones} ${styles[theme]}`}>

        <div style={{ display: 'flex', flexDirection: 'row', gap: '10px' }}>
           
            <Card className={`${styles.card} ${styles[theme]}`}sx={{ width: 650, height:50 }}>
                <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, pr: 2 }}>
                    <FormControl size="small" sx={{ minWidth: 260 }}>
                        <InputLabel id="company-label">Company</InputLabel>
                        <Select
                            labelId="company-label"
                            label="Company"
                            value={selectedCompanyName}
                            onChange={handleCompanyChange}
                            className={`${styles.select} ${styles[theme]}`} >
                            <MenuItem value="">None</MenuItem>
                            <MenuItem value={ALL_COMPANIES_VALUE}>All Companies</MenuItem>
                            {companyOptions.map((companyName) => (
                            <MenuItem key={companyName} value={companyName}>
                                {companyName}
                            </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                    <FormControl size="small" sx={{ minWidth: 260 }} disabled={!selectedCompanyName}>
                        <InputLabel id="location-label">Location</InputLabel>
                        <Select
                            labelId="location-label"
                            label="Location"
                            value={selectedLocationId}
                            onChange={handleLocationChange}
                            className={`${styles.select} ${styles[theme]}`} >
                            <MenuItem value="">None</MenuItem>
                            {selectedCompanyName === ALL_COMPANIES_VALUE && (
                              <MenuItem value={ALL_LOCATIONS_VALUE}>All</MenuItem>
                            )}
                            {filteredLocations.map((loc) => (
                            <MenuItem key={loc.id} value={String(loc.id)}>
                                {selectedCompanyName === ALL_COMPANIES_VALUE ? loc.label : (loc.divisionName || loc.label)}
                            </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                    
                </Box>
                </div>
            </Card>


             <Card className={`${styles.card} ${styles[theme]}`} sx={{ width: 750,height:50 }}>
              <CardContent>
                <Typography sx={{ fontSize: 14,  }} gutterBottom>
                <span className={`${styles[theme]}Text`}>Mill Information</span>
                </Typography>
               
             </CardContent>
            </Card>
       
            <Card className={`${styles.card} ${styles[theme]}`}sx={{ width: 600, height:50 }}> 
              <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
              <CardContent>
                <Button style={{fontSize:'12px', marginTop:'-15px'}} onClick={handleAddZoneOpen} disabled={!selectedLocationId || selectedLocationId === ALL_LOCATIONS_VALUE} > <TbZoomInAreaFilled style={{fontSize:'30px', margin:'0px', paddingRight:'3px', paddingTop:'-10px'}}  />Add Zone</Button>
                <Button style={{fontSize:'12px', marginTop:'-15px'}} onClick={handleAddTagOpen}  > <TbCircleDashedLetterT style={{fontSize:'30px', margin:'0px', paddingRight:'3px', paddingTop:'-10px'}}  />Add Tag</Button>
                <Button style={{fontSize:'12px', marginTop:'-15px'}} onClick={handleAddCategoryOpen}  > <TbCircleDashedLetterC style={{fontSize:'30px', margin:'0px', paddingRight:'3px', paddingTop:'-10px'}}  />Add Tag Category</Button>

              
              </CardContent>
               </div>
            </Card>
            </div>
 

      <Box sx={{ display: 'flex', flexDirection: 'row', width: '100%' }}>
        <Box sx={{ m: 1, width: '100%' }}>
          <Paper elevation={1} className={`${styles.card} ${styles[theme]}`}>
            <Box
              className={`${styles.box} ${styles[theme]}`}
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                
              }}
            >
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 0 }}>
                <Typography
                  sx={{
                    fontFamily: 'DM Serif Display, serif',
                    fontWeight: 400,
                    fontStyle: 'normal',
                    textAlign: 'left',
                    pl: '10px',
                    color: isDark ? '#f5f5f5' : '#111827',
                  }}
                  variant="h6"
                  gutterBottom
                >
                  Zones Overview
                </Typography>
                <Box className={styles.legend} sx={{alignItems: 'center', gap: 0, marginTop:'10px' }}>
                    <span className={`${styles.swatch} ${styles.swatchGreen}`} /> Active
                    <span className={`${styles.swatch} ${styles.swatchRed}`} /> Inactive
                </Box>
               
              </Box>
          
            </Box>

            {/* Grid of zone boxes */}
            <Box className={styles.grid}>
              {ZONE_KEYS.map((k, idx) => {
                const isActive = activeScanZones.has(idx);
                return (
                  <button
                    key={k}
                    type="button"
                    className={`${styles.zone} ${styles[theme]} ${isActive ? styles.active : styles.inactive}`}
                    style={{ position: 'relative' }}
                  >
                    {closedLoopScanZones.has(idx) && (
                      <GrCycle style={{ position: 'absolute', top: 1, right: 8, fontSize: 20, color: '#ffffff' }} />
                    )}
                    <span className={styles.zoneLabel}>{k}</span>
                  </button>
                );
              })}
            </Box>

           
          </Paper>
        </Box>
      </Box>

      {/* Zones table for selected location */}
      <Box sx={{ m: 1 }}>
        <Paper elevation={1} className={`${styles.card} ${styles[theme]}`}>
          <Box
            className={styles.box + ' ' + styles[theme]}
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 2,
              px: 2,
              py: 1,
            }}
          >
            <Box sx={{ minWidth: 220 }} />
            <Typography
              sx={{
                fontFamily: 'DM Serif Display, serif',
                fontWeight: 400,
                fontStyle: 'normal',
                flexGrow: 1,
                textAlign: 'center',
                color: isDark ? '#f5f5f5' : '#111827',
              }}
              variant="h6"
              gutterBottom
            >
              {tableTitle}
            </Typography>
            <FormControl size="small" sx={{ minWidth: 220 }}>
              <InputLabel id="tag-category-filter-label" className={theme === 'light' ? styles.lightLabel : styles.darkLabel}>Tag Category</InputLabel>
              <Select
                labelId="tag-category-filter-label"
                label="Tag Category"
                value={selectedTagCategoryFilter}
                onChange={(e) => setSelectedTagCategoryFilter(String(e.target.value))}
                className={styles.select + ' ' + styles[theme]}
              >
                <MenuItem value="">All Categories</MenuItem>
                {tagCategories.map((cat) => {
                  const value = cat?.TagCategoryID ?? cat?.id;
                  if (value === undefined || value === null) {
                    return null;
                  }
                  return (
                    <MenuItem key={String(value)} value={String(value)}>
                      {cat?.Name || value}
                    </MenuItem>
                  );
                })}
              </Select>
            </FormControl>
          </Box>
          <Box sx={{ p: 2 }}>
            <DataGrid
              className="my-datagrid"
              autoHeight
              sx={{
                borderColor: isDark ? '#2c2c2b' : '#d7dce2',
                color: isDark ? '#d8d8d8' : '#111827',
                backgroundColor: isDark ? '#0c0c0c' : '#ffffff',
                '& .MuiDataGrid-columnHeaders': {
                  backgroundColor: isDark ? '#191919' : '#f7f8fa',
                  color: isDark ? '#f3f4f6' : '#111827',
                  borderBottomColor: isDark ? '#2c2c2b' : '#d7dce2',
                },
                '& .MuiDataGrid-cell': {
                  borderBottomColor: isDark ? '#2c2c2b' : '#e5e7eb',
                },
                '& .MuiDataGrid-footerContainer': {
                  backgroundColor: isDark ? '#0c0c0c' : '#ffffff',
                  color: isDark ? '#d8d8d8' : '#111827',
                  borderTopColor: isDark ? '#2c2c2b' : '#d7dce2',
                },
                '& .MuiTablePagination-root, & .MuiTablePagination-toolbar, & .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows, & .MuiSvgIcon-root': {
                  color: isDark ? '#d8d8d8' : '#111827',
                },
                '& .MuiDataGrid-row:hover': {
                  backgroundColor: isDark ? '#151515' : '#f9fafb',
                },
              }}
              rows={tableRows}
              columns={[
                { field: 'LocationName', headerName: 'Location Name', width: 260 },
                { field: 'ZoneName', headerName: 'Zone Name', width: 240 },
                { field: 'ZoneDesc', headerName: 'Description', width: 360 },
                { field: 'ScanZone', headerName: 'Scan Zone', width: 200, valueFormatter: (p) => (Number.isFinite(p.value) ? ZONE_KEYS[p.value] : '') },
                { field: 'Tags', headerName: 'Tags', width: 280 },
                { field: 'TagCategoryNames', headerName: 'Tag Categories', width: 260 },
                { field: 'Edit', headerName: 'Edit', sortable: false, width: 80, renderCell: (params) => (
                  <CiEdit style={{ fontSize: '26px', cursor: 'pointer' }} onClick={() => handleEditZone(params.row)} />
                ) },
                { field: 'Delete', headerName: 'Delete', sortable: false, width: 90, renderCell: (params) => (
                  <RiDeleteBack2Line style={{ fontSize: '24px', cursor: 'pointer', color: '#7d2110' }} onClick={() => handleDeleteZone(params.row)} />
                ) },
              ]}
              pageSizeOptions={[5, 10, 25]}
              initialState={{ pagination: { paginationModel: { pageSize: 10 } } }}
              disableRowSelectionOnClick
            />
          </Box>
        </Paper>
      </Box>
                  {/* DIALOG1 */}
                  {/* ADD NEW TAG */}
                  {/* DIALOG1 */}
      
                  <Dialog className={`${styles[theme]}`}
                                            PaperProps={{
                                              className: theme === 'light' ? styles['light-dialogPaper'] : styles['dark-dialogPaper'],
                                            }} open={addTagOpen} onClose={() => setAddTagOpen(false)} maxWidth="md" >
  
                    <DialogTitle>ADD NEW TAG</DialogTitle>
                    <br />
                    <DialogContent>
                      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, minWidth: 500 }}>
                        <TextField
                          label="Tag Name"
                          size="small"
                          value={tagName}
                          onChange={(e) => setTagName(e.target.value)}
                          className={theme === 'light' ? styles.lightTextField : styles.darkTextField}
                          InputProps={{ className: theme === 'light' ? styles.lightInput : styles.darkInput }}
                          InputLabelProps={{ className: theme === 'light' ? styles.lightLabel : styles.darkLabel }}
                        />
                        <TextField
                          label="Tag Description"
                          size="small"
                          multiline
                          minRows={2}
                          value={tagDesc}
                          onChange={(e) => setTagDesc(e.target.value)}
                          className={theme === 'light' ? styles.lightTextField : styles.darkTextField}
                          InputProps={{ className: theme === 'light' ? styles.lightInput : styles.darkInput }}
                          InputLabelProps={{ className: theme === 'light' ? styles.lightLabel : styles.darkLabel }}
                        />
                        <FormControl size="small">
                          <InputLabel id="tag-category-label" className={theme === 'light' ? styles.lightLabel : styles.darkLabel}>Tag Category</InputLabel>
                          <Select
                            labelId="tag-category-label"
                            label="Tag Category"
                            value={selectedCategory}
                            onChange={(e) => setSelectedCategory(String(e.target.value))}
                            className={theme === 'light' ? styles.lightSelect : styles.darkSelect}
                          >
                            <MenuItem value="">None</MenuItem>
                            {tagCategories.map((c) => (
                              <MenuItem key={c.TagCategoryID || c.id} value={String(c.TagCategoryID || c.id)}>
                                {c.Name}
                              </MenuItem>
                            ))}
                            <MenuItem value={ADD_NEW_VALUE} sx={{ fontStyle: 'italic' }}>+ Add new category…</MenuItem>
                          </Select>
                        </FormControl>
                        {selectedCategory === ADD_NEW_VALUE && (
                          <TextField
                            label="New Category Name"
                            size="small"
                            value={newCategoryName}
                            onChange={(e) => setNewCategoryName(e.target.value)}
                            className={theme === 'light' ? styles.lightTextField : styles.darkTextField}
                            InputProps={{ className: theme === 'light' ? styles.lightInput : styles.darkInput }}
                            InputLabelProps={{ className: theme === 'light' ? styles.lightLabel : styles.darkLabel }}
                          />
                        )}
                      </Box>
                    </DialogContent>
                    <DialogActions sx={{ marginRight:'20px' }}>
                        <Button variant="contained" color="error" onClick={handleAddTagClose}>Cancel</Button>
                        <Button
                          variant="contained"
                          color="success"
                          onClick={handleSaveTag}
                          disabled={
                            !tagName.trim() ||
                            !selectedCategory ||
                            (selectedCategory === ADD_NEW_VALUE && !newCategoryName.trim())
                          }
                        >
                          Save
                        </Button>
                    </DialogActions>
                  </Dialog>

                  {/* DIALOG3: ADD NEW TAG CATEGORY */}
                  <Dialog className={`${styles[theme]}`}
                    PaperProps={{ className: theme === 'light' ? styles['light-dialogPaper'] : styles['dark-dialogPaper'] }}
                    open={addCategoryOpen} onClose={handleAddCategoryClose} maxWidth="sm">
                    <DialogTitle>ADD NEW TAG CATEGORY</DialogTitle>
                    <br />
                    <DialogContent>
                      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, minWidth: 420 }}>
                        <TextField
                          label="Category Name"
                          size="small"
                          value={categoryNameInput}
                          onChange={(e) => setCategoryNameInput(e.target.value)}
                          className={theme === 'light' ? styles.lightTextField : styles.darkTextField}
                          InputProps={{ className: theme === 'light' ? styles.lightInput : styles.darkInput }}
                          InputLabelProps={{ className: theme === 'light' ? styles.lightLabel : styles.darkLabel }}
                        />
                      </Box>
                    </DialogContent>
                    <DialogActions sx={{ marginRight:'20px' }}>
                      <Button variant="contained" color="error" onClick={handleAddCategoryClose}>Cancel</Button>
                      <Button variant="contained" color="success" onClick={handleSaveCategory} disabled={!categoryNameInput.trim()}>Save</Button>
                    </DialogActions>
                  </Dialog>

                  {/* DIALOG2: ADD NEW ZONE */}
                  <Dialog className={`${styles[theme]}`}
                    PaperProps={{ className: theme === 'light' ? styles['light-dialogPaper'] : styles['dark-dialogPaper'] }}
                    open={addZoneOpen} onClose={handleAddZoneClose} maxWidth="md">
                    <DialogTitle>ADD NEW ZONE</DialogTitle>
                    <br />
                    <DialogContent>
                      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, minWidth: 520 }}>
                        <TextField
                          label="Zone Name"
                          size="small"
                          value={zoneName}
                          onChange={(e) => setZoneName(e.target.value)}
                          className={theme === 'light' ? styles.lightTextField : styles.darkTextField}
                          InputProps={{ className: theme === 'light' ? styles.lightInput : styles.darkInput }}
                          InputLabelProps={{ className: theme === 'light' ? styles.lightLabel : styles.darkLabel }}
                        />
                        <TextField
                          label="Zone Description"
                          size="small"
                          multiline
                          minRows={2}
                          value={zoneDesc}
                          onChange={(e) => setZoneDesc(e.target.value)}
                          className={theme === 'light' ? styles.lightTextField : styles.darkTextField}
                          InputProps={{ className: theme === 'light' ? styles.lightInput : styles.darkInput }}
                          InputLabelProps={{ className: theme === 'light' ? styles.lightLabel : styles.darkLabel }}
                        />
                        <FormControl size="small">
                          <InputLabel id="scan-zone-label" className={theme === 'light' ? styles.lightLabel : styles.darkLabel}>Scan Zone</InputLabel>
                          <Select
                            labelId="scan-zone-label"
                            label="Scan Zone"
                            value={selectedScanZone}
                            onChange={(e) => setSelectedScanZone(String(e.target.value))}
                            className={theme === 'light' ? styles.lightSelect : styles.darkSelect}
                          >
                            <MenuItem value="">None</MenuItem>
                            {ZONE_KEYS.map((name, idx) => (
                              <MenuItem key={idx} value={String(idx)}>
                                {name}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                        <FormControl size="small">
                          <InputLabel id="zone-tags-label" className={theme === 'light' ? styles.lightLabel : styles.darkLabel}>Tags</InputLabel>
                          <Select
                            labelId="zone-tags-label"
                            label="Tags"
                            multiple
                            value={selectedTagIds}
                            onChange={(e) => setSelectedTagIds(typeof e.target.value === 'string' ? e.target.value.split(',') : e.target.value)}
                            renderValue={(selected) => (
                              <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                                {selected.map((id) => {
                                  const t = allTags.find(x => String(x.TagID || x.id) === String(id));
                                  return <Chip key={id} label={t ? t.Name : id} size="small" />
                                })}
                              </Box>
                            )}
                            className={theme === 'light' ? styles.lightSelect : styles.darkSelect}
                          >
                            {allTags.map(t => (
                              <MenuItem key={t.TagID || t.id} value={String(t.TagID || t.id)}>
                                {t.Name}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </Box>
                    </DialogContent>
                    <DialogActions sx={{ marginRight:'20px' }}>
                      <Button variant="contained" color="error" onClick={handleAddZoneClose}>Cancel</Button>
                      <Button variant="contained" color="success" onClick={handleSaveZone} disabled={!zoneName.trim() || selectedScanZone === '' || !selectedLocationId || selectedLocationId === ALL_LOCATIONS_VALUE}>Save</Button>
                    </DialogActions>
                  </Dialog>
    </aside>
  );
};

export default Zones;
